export default __webpack_public_path__ + "static/media/lineArrowSm.940d5fc4.svg";